import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Paper } from '@material-ui/core'
import { CircularProgressLoader } from 'components/global-progress-modal/global-progress-modal'

const useStyles = makeStyles(() => ({
    uploadSection: {},
    documentContainer: {
        width: '532px',
        height: '700px',
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: 'white'
    },
    loaderContainer: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1000
    },
    imageContainer: {
        maxHeight: '840px',
        overflowY: 'auto',
        width: '532px',
        borderRadius: '8px',
        background: 'white',
        padding: '8px'
    },
    previewImage: {
        width: '100%',
        height: 'auto',
        marginBottom: '16px',
        objectFit: 'contain',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
    },
    contentContainer: {
        paddingLeft: '2rem',
        paddingRight: '2rem'
    }
}))

interface PreviewTemplateComponentProps {
    imageUrlsData?: string[]
    pageCount?: number
    loading?: boolean
}

const PreviewTemplateComponent: React.FC<PreviewTemplateComponentProps> = ({
    imageUrlsData = [],
    loading
}) => {
    const classes = useStyles()

    return (
        <Paper className={classes.uploadSection} elevation={0}>
            <div className={classes.contentContainer}>
                {loading && (
                    <div className={classes.loaderContainer}>
                        <CircularProgressLoader />
                    </div>
                )}
                {!loading && imageUrlsData && imageUrlsData.length > 0 && (
                    <div className={classes.imageContainer}>
                        {imageUrlsData.map((img, idx) => (
                            <img
                                key={idx}
                                src={img}
                                alt={`Template Preview Page ${idx + 1}`}
                                className={classes.previewImage}
                            />
                        ))}
                    </div>
                )}
            </div>
        </Paper>
    )
}

export default PreviewTemplateComponent
